export const AGORA_APP_ID = "67928ae94ec149a9aa489ec7b9d818a3";

// NOTA: este ficheiro já teve um objeto `rtc` com um cliente AgoraRTC criado
// logo no import. Era a raiz de vários problemas: o cliente nascia no arranque
// da app (mesmo para quem nunca entrava numa partida), era partilhado por
// todos os ecrãs ao mesmo tempo, os handlers "user-published" acumulavam-se a
// cada revanche porque ninguém os removia, e como nunca era destruído as
// câmaras ficavam acesas depois de sair do estádio.
//
// A gestão de sessões passou para ./agoraSession.js, que cria um cliente novo
// por partida e garante o fecho (despublicar → parar/fechar pistas → remover
// handlers → sair do canal → largar o cliente). Ver também ./useSessaoAgora.js.
